var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.ready
    ? _c(
        "app-draggable",
        {
          staticClass: "container",
          attrs: {
            x: _vm.x,
            y: _vm.y,
            "min-x": _vm.minX,
            "min-y": _vm.minY,
            "max-x": _vm.computedMaxX,
            "max-y": _vm.computedMaxY,
            "disable-x": _vm.disableX,
            "disable-y": _vm.disableY,
          },
          on: {
            "update:x": function ($event) {
              return _vm.$emit("update:x", $event)
            },
            "update:y": function ($event) {
              return _vm.$emit("update:y", $event)
            },
            "mouse-down": function ($event) {
              return _vm.computeMaxValues()
            },
          },
        },
        [
          _c(
            "app-resizable",
            {
              attrs: {
                width: _vm.width,
                height: _vm.height,
                "min-width": _vm.minWidth,
                "max-width": _vm.computedMaxWidth,
                "min-height": _vm.minHeight,
                "max-height": _vm.computedMaxHeight,
              },
              on: {
                "update:width": function ($event) {
                  return _vm.$emit("update:width", $event)
                },
                "update:height": function ($event) {
                  return _vm.$emit("update:height", $event)
                },
                "mouse-down": function ($event) {
                  return _vm.computeMaxValues()
                },
              },
            },
            [_vm._t("default")],
            2
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }